import { PhotogrammetryMaterial } from '@asset-viz/materials/PhotogrammetryMaterial'
import { useSurfaceProps } from '../util/SurfaceProvider'
import { RenderOrder } from '@asset-viz/utils/renderingDefines'
import React from 'react'
import { ComponentSurfaceWrappingMode } from 'types'

/**
 * A layer used to render a Photogrammetry texture on a component's surface
 * @constructor
 */
export const PhotogrammetryLayerChunk3D: React.FC = () => {
  //----------------------------------------------------------------------------

  const { bounds, geometry, wrapMode } = useSurfaceProps()

  return (
    <mesh
      name={'photogrammetry_texture_chunk'}
      geometry={geometry}
      renderOrder={RenderOrder.Photogrammetry}>
      <PhotogrammetryMaterial
        // Chunk dimensions
        chunkBounds={bounds}
        doWrapX={wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsX}
        doWrapY={wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsY}
      />
    </mesh>
  )
}
